





















import {
  Component, Vue, Watch, mixins, mapState,
} from '@samclick-commons';
import SamclickMixins from '@/utils/mixins';
import {
  IntroductionStore, Payload,
} from '@/state/modules';
import {AuthorizationStore} from '@samclick-store-factory';

class IntroductionState {

}


    @Component({
      /**
         * Imported components
         * */
      components: {
      },
      /**
         * Stores values
         * */
      computed: {
        ...mapState({
          beginnersGuide: (state: any) => state.introductions.introductionStore.beginnersGuide,
        }),
      },
      /**
         * Component properties
         * */
      props: {},
    })


export default class Introduction extends mixins(SamclickMixins) {
        /**
         * Local state
         * */
        state = new IntroductionState();

        selectedLang = '';


        /**
         * Watchers
         * */
        @Watch('ifLocaleChange', { immediate: true })
        langChangea(val: string) {
          this.getListBeginnersGuide();
        }

        getListBeginnersGuide() {
            const lang = this.$i18n.i18next.language;
            const userSubscription = AuthorizationStore.getCurrentUserSubscription
            IntroductionStore.getListBeginnersGuide(new Payload({
                language: lang,
                market: userSubscription,
            }));
        }


        /**
         * Methods
         * */
        getGuide(fileName:string) {
          IntroductionStore.getBeginnersGuide(new Payload({
            fileName,
          }));
        }


        /**
         * Computed
         * */

        /**
         * Lifecycle hooks
         * */
        created() {
          this.getListBeginnersGuide();
        }

        mounted() {
          this.selectedLang = this.$i18n.i18next.language;
        }

        beforeUpdate() {
        }
}
